module.exports = __webpack_public_path__ + "static/media/cosmonautBlue.b190679d.svg";